<template>
  <v-responsive
    class="bookmark-thumbnail pos-relative rounded" :class="colors"
    :aspect-ratio="aspectRatio" v-bind="$attrs"
  >
    <!-- FIXME v-img cannot be empty or it flickers/re-renders component weirdly -->
    <!-- probably move away from v-img entirely for anything inside virtual scroller views cuz of inters. obser. -->
    <!-- Can just style the v-responsive div with background-url and size cover -->
    <v-img
      :src="src"
      :alt="bookmark.title"
      class="bookmark-image"
      cover
    >
      <template #placeholder>
        <v-skeleton-loader type="image" class="image-loader" />
      </template>
    </v-img>
  </v-responsive>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { THUMBNAIL_ASPECT_RATIO } from '@/utils/constants'

// Vue 3 script setup - inheritAttrs: false
const props = defineProps({
  bookmark: {
    type: Object,
    required: true,
  },
  // width / height; a tier list card keeps an upload's original ratio with it
  aspectRatio: {
    type: Number,
    default: THUMBNAIL_ASPECT_RATIO,
  },
})

// The CDN thumbnail is a 16:9 crop. A box of another ratio loads the whole image,
// so `cover` crops it once to the box instead of cropping the crop.
const src = computed(() => (props.aspectRatio === THUMBNAIL_ASPECT_RATIO
  ? props.bookmark.thumbnailUrl
  : props.bookmark.uncroppedThumbnailUrl))

const colors = computed(() => {
  if (props.bookmark.image) return 'neutral25'
  return props.bookmark.colorClasses
})
</script>

<script>
// Using normal script block to set options
export default {
  inheritAttrs: false
}
</script>

<style lang="scss" scoped>
.image-loader {
  @include overlay;

  :deep(.v-skeleton-loader__image) {
    background-color: rgb(var(--v-theme-neutral50));
  }
}

.placeholder-svg {
  @include overlay;
}

.bookmark-image {
  @include overlay;
}
</style>
